<script setup lang="ts">
import { Markdown } from '@tiptap/markdown'
import DE_DE from '@vavt/cm-extension/dist/locale/de-DE'
import { config } from 'md-editor-v3'
import { match } from 'ts-pattern'
import { z } from 'zod'

import { dirtyFlags } from './composables/useIsAnyFormDirty'

const router = useRouter()

z.setErrorMap((issue) => {
  return {
    message:
      issue.message
      ?? match(issue)
        .with(
          {
            code: 'invalid_string',
          },
          (i) =>
            match(i.validation)
              .with('email', () => 'Ungültige E-Mail-Adresse')
              .with('datetime', () => 'Ungültiges Datum')
              .otherwise(() => 'Ungültige Eingabe'),
        )
        .with(
          {
            code: 'too_big',
          },
          (i) =>
            i.type === 'number'
              ? `Wert darf nicht größer als ${i.maximum} sein`
              : `Text darf nicht länger als ${i.maximum} Zeichen sein`,
        )
        .with(
          {
            code: 'too_small',
          },
          (i) =>
            i.type === 'number'
              ? `Wert darf nicht kleiner als ${i.minimum} sein`
              : `Text darf nicht kürzer als ${i.minimum} Zeichen sein`,
        )
        .otherwise(() => 'Ungültige Eingabe'),
  }
})

function handleBeforeUnload(event: BeforeUnloadEvent) {
  if (Object.values(dirtyFlags.value).length > 0) {
    event.preventDefault()
    event.returnValue = ''
  }
}

onMounted(() => {
  window.addEventListener('beforeunload', handleBeforeUnload)
})

onBeforeUnmount(() => {
  window.removeEventListener('beforeunload', handleBeforeUnload)
})

router.beforeEach(async (to, from, next) => {
  if (Object.values(dirtyFlags.value).length > 0 && to.name !== from.name) {
    const answer = await useConfirm('')
    if (!answer) {
      return next(false) // blockiere Navigation
    }
  }
  next()
})

config({
  editorConfig: {
    languageUserDefined: {
      'de-DE': DE_DE,
    },
  },
  markdownItConfig(mdit) {
    mdit.block.ruler.disable('code')
  },
})

Markdown.configure({
  markedOptions: {
    gfm: true,
  },
})
</script>

<template>
  <div>
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
    <UNotifications>
      <template #description="{ description }">
        <span style="white-space: pre-line">{{ description }}</span>
      </template>
    </UNotifications>

    <OpenFormWarningModal />
  </div>
</template>
